import { Select } from "antd";
import styled from "styled-components";

const StyledSelect = styled(Select)`
  width: 100%;
`;

/**
 * Display component for multi-select values
 * Handles: arrays (including nested arrays), single value
 */
function UdfMultiSelectDisplay({ value }) {
  if (value === null || value === undefined) {
    return null;
  }

  // Handle array - could be array of arrays in filter mode
  if (Array.isArray(value)) {
    // Check if it's an array of arrays
    if (value.length > 0 && Array.isArray(value[0])) {
      // Flatten nested arrays for display
      return (
        <>
          {value.map((val, index) => (
            <span key={index}>
              <UdfMultiSelectDisplay value={val} />
              {index < value.length - 1 && ", "}
            </span>
          ))}
        </>
      );
    }
    // Regular array - join with commas
    return <>{value.join(", ")}</>;
  }

  return String(value);
}

/**
 * Multi-select input component for UDF filters
 */
function UdfMultiSelectEdit({ addValue, currentValue, setCurrentValue, choices = [] }) {
  return (
    <StyledSelect
      popupMatchSelectWidth={false}
      placeholder="Select one or more options..."
      value={currentValue ?? null}
      onChange={(value) => {
        if (value) {
          addValue(value);
          setCurrentValue(null);
        }
      }}
      options={choices.map((choice) => ({
        label: choice,
        value: choice,
      }))}
      showSearch
      filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
    />
  );
}

/**
 * Factory function that returns both Edit and Display components
 */
function UdfMultiSelect() {
  return {
    Edit: UdfMultiSelectEdit,
    Display: UdfMultiSelectDisplay,
  };
}

export default UdfMultiSelect;
